export const INSUFFICIENT_BALANCE_ERROR = "Insufficient balance"
